// extracted by mini-css-extract-plugin
export default {"text-header":"ServiceListItem_text-header__+8-dS","paragraph":"ServiceListItem_paragraph__c94dR"};